import React from 'react'
import PropTypes from 'prop-types'
import { Card, Button, FontAwesome } from '../../components'

import './summary.scss'

const Summary = ({
  className,
  currentRole,
  education,
  experience,
  isHighSchoolStudent,
  isEditable,
  action,
  ugMajor
}) => (
  <>
    {/* <p className='g--font-h4'>Your career so far</p> */}
    <Card className={`summary ${className}`}>
      <div className='row row--space-between row--align-center'>
        <div className='row__column summary__user'>
          <Button
            icon='user'
            variant=' button--tertiary button--default g--margin-right-small hide--tablet'
          />
          <p className='g--margin-none g--font-body-bold'>
            {"What you've told us so far"}
          </p>
        </div>
        {isEditable && (
          <div className='row__column '>
            <Button
              icon='edit'
              action={action}
              Wrapper={'button'}
              wrapperProps={{ onClick: action }}
              variant='cta'
            />
          </div>
        )}
      </div>
      {isHighSchoolStudent && (
        <div className='statistic'>
          <FontAwesome className='statistic__icon' icon='school' />
          <p className='statistic__copy g--margin-none g--font-body'>
            High School Student
          </p>
        </div>
      )}
      {education && (
        <div className='statistic'>
          <FontAwesome className='statistic__icon' icon='graduation-cap' />
          <p className='statistic__copy g--margin-none g--font-body'>
            {education}
          </p>
        </div>
      )}
      {currentRole && (
        <div className='statistic'>
          <FontAwesome className='statistic__icon' icon='briefcase' />
          <p className='statistic__copy g--margin-none g--font-body'>
            {currentRole}
          </p>
        </div>
      )}
      {experience &&
        (experience !== 'Student' ? (
          <div className='statistic'>
            <FontAwesome className='statistic__icon' icon='clock' />
            <p className='statistic__copy g--margin-none g--font-body'>
              {experience + ' years experience'}
            </p>
          </div>
        ) : (
          <div className='statistic'>
            <FontAwesome className='statistic__icon' icon='book-open' />
            <p className='statistic__copy g--margin-none g--font-body'>
              {ugMajor}
            </p>
          </div>
        ))}
    </Card>
  </>
)

Summary.defaultProps = {
  className: '',
  firstName: '',
  lastName: '',
  currentRole: '',
  education: '',
  experience: '',
  isEditable: false,
  isHighSchoolStudent: false,
  action: () => {}
}

Summary.propTypes = {
  className: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  currentRole: PropTypes.string,
  education: PropTypes.string,
  experience: PropTypes.string,
  isEditable: PropTypes.bool,
  isHighSchoolStudent: PropTypes.bool,
  action: PropTypes.func
}

export default Summary
